import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Img from '@/components/shared/Img';

export default function TeamSection() {
  return (
    <section className="relative py-20 md:py-28 bg-[#0a0a0a] border-t border-white/10">

      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Photo */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative">
            
            <div className="relative overflow-hidden rounded-sm">
              <Img
                src="/images/c90c30667_IMG_3836__1_.jpeg"
                alt="Justin — founder of Terza Costa Construction, Rockport TX"
                className="w-full h-[400px] md:h-[500px] object-cover object-center"
                sizes="(min-width: 1024px) 50vw, 100vw"
              />

              
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            </div>
            {/* Orange corner accent */}
            <div className="absolute bottom-0 right-0 w-20 h-20">
              <div className="absolute bottom-0 right-0 w-full h-px bg-[#C97B2E]" />
              <div className="absolute bottom-0 right-0 w-px h-full bg-[#C97B2E]" />
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="flex flex-col justify-center">
            
            <div className="w-12 h-px bg-[#C97B2E] mb-6" />
            <span className="font-body text-[#C97B2E] text-xs font-bold uppercase tracking-[0.3em] mb-4">
              The People Behind The Work
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
              The People Behind The Work
            </h2>
            <p className="font-body text-white/65 text-base leading-relaxed mb-5">
              Terza Costa Construction is built around one guiding idea: treat every client's home like it's your own. 
              Justin founded Terza Costa with a simple promise — show up on time, communicate clearly, protect the home, 
              and never cut corners.
            </p>
            <p className="font-body text-white/65 text-base leading-relaxed mb-8">
              Every job — from a single EV charger install to a full master bathroom remodel — gets the same 
              level of care. That's not just a tagline. It's how we've earned every five-star review 
              across the Coastal Bend.
            </p>
            {/* Wraps below sm — three stats plus dividers overflowed a 320px viewport */}
            <div className="flex flex-wrap items-start gap-x-6 gap-y-5 sm:gap-8 mb-8">
              <div>
                <p className="font-heading text-3xl font-bold text-white">5★</p>
                <p className="font-body text-white/60 text-xs uppercase tracking-wider">Google Reviews</p>
              </div>
              <div className="w-px self-stretch bg-white/10 hidden sm:block" />
              <div>
                <p className="font-heading text-3xl font-bold text-white">100%</p>
                <p className="font-body text-white/60 text-xs uppercase tracking-wider">Licensed & Insured</p>
              </div>
              <div className="w-px self-stretch bg-white/10 hidden sm:block" />
              <div>
                <p className="font-heading text-3xl font-bold text-white">Local</p>
                <p className="font-body text-white/60 text-xs uppercase tracking-wider">Rockport, TX</p>
              </div>
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 font-body text-[#C97B2E] text-sm font-bold uppercase tracking-wider hover:text-white transition-colors group">
              
              Learn More About Us
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
            </Link>
          </motion.div>
        </div>
      </div>
    </section>);

}